// extracted by mini-css-extract-plugin
export default {"overlayWrapper":"Overlay_overlayWrapper__L1inQ","infoOverlayWrapper":"Overlay_infoOverlayWrapper__KxV46","explainNav":"Overlay_explainNav__oWNef"};